import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ecde3ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media m-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "media-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "image is-48x48" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "",
      src: "/img/Chest.png"
    })
  ])
], -1))
const _hoisted_3 = { class: "media-content" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "media m-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "media-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "image is-48x48" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "",
      src: "/img/Chest.png"
    })
  ])
], -1))
const _hoisted_9 = { class: "media-content has-text-left" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", { class: "level is-mobile" }, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("No comments yet! ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Why don't you say something?")
const _hoisted_18 = [
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.content) = $event)),
              class: "textarea",
              placeholder: "Add a comment..."
            }, null, 512), [
              [_vModelText, _ctx.content]
            ])
          ])
        ]),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          class: "button is-info is-pulled-right"
        }, "Submit")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (c, index) => {
        return (_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("article", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, _toDisplayString(c.username), 1),
                  _hoisted_11,
                  _createElementVNode("small", null, _toDisplayString(_ctx.ago(c.comment_time)), 1),
                  _hoisted_12,
                  _createTextVNode(" " + _toDisplayString(c.content), 1)
                ])
              ]),
              _hoisted_13
            ])
          ])
        ]))
      }), 256))
    ]),
    (_ctx.comments.length==0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_18))
      : _createCommentVNode("", true),
    (_ctx.comments.length > 19)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "button mb-3",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
        }, "Load More"))
      : _createCommentVNode("", true)
  ], 64))
}